<div class="create-query-container ant-advanced-search-form" nzCompact>
  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Requestor Details</span>
  </div>
  <br />


<div class="row form-group">
  <div class="col-md-2">
    <label>Requestor Name</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.RequestorName}}" name="RequestorName" type="text" class="form-control"
      disabled />
  </div>
</div>
<div class="form-row bg-dark-blue text-white">
  <span class="span-header">Query Details</span>
</div>
<br />
<div class="row form-group">
  <div class="col-md-2">
    <label>Date of Request</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.RequestDate | date:'dd-MMM-yyyy'}}" name="RequestDate" class="form-control"
      disabled />
  </div>

  <div class="col-md-3 col-md-push-1" *ngIf="queryDetail.QueryDetailStatus == 6">
    <label>Completion Date</label>
  </div>
  <div class="col-md-3" *ngIf="queryDetail.QueryDetailStatus == 6">
    <input nz-input value="{{queryDetail.CompletionDate | date:'dd-MMM-yyyy'}}" name="CompletionDate"
      class="form-control" disabled />
  </div>

    <div class="col-md-3 col-md-push-1" *ngIf="queryDetail.QueryDetailStatus != 6">
      <label>Request Status</label>
    </div>
    <div class="col-md-3" *ngIf="queryDetail.QueryDetailStatus != 6">
      <input nz-input value="{{requestStatus}}" name="CompletionDate" class="form-control" disabled />
    </div>

</div>
<div class="row form-group">
  <div class="col-md-2">
    <label>Subject</label>
  </div>
  <div class="col-md-3">
    <input nz-input name="Subject" type="text" class="form-control" disabled value="{{Subject}}" title="{{Subject}}" />
  </div>
  <div class="col-md-3 col-md-push-1">
    <label>Priority</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.PriorityLevel}}" title="{{queryDetail.PriorityLevel}}" name="PriorityLevel"
      type="text" class="form-control" disabled />
  </div>
</div>
<div class="row form-group">
  <div class="col-md-2">
    <label>CC Emails</label>
  </div>
  <div class="col-md-3">
    <textarea nz-input type="text" rows="3" class="form-control" name="CCEmails" value="{{queryDetail.CCEmails}}"
      disabled></textarea>
  </div>
  <div class="col-md-3 col-md-push-1">
    <label>Confidential</label>
  </div>
  <div class="col-md-3">
    <input nz-input type="checkbox" name="Partner_Confidential" class="chckbx-Confidential"
      [checked]="queryDetail.Is_Confidential" onclick="return false;" />
  </div>
</div>
<div class="form-row bg-dark-blue text-white">
  <span class="span-header">Clarification Request Details</span>
</div>
<br />
<div class="row form-group">
  <div class="col-md-2">
    <label>Block</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.Block}}" name="queryDetail.Block" type="text" class="form-control" disabled />
  </div>
  <div class="col-md-3 col-md-push-1">
    <label>Company</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.CompanyName}}" name="CompanyName" type="text" class="form-control" disabled />
  </div>

</div>
<div class="row form-group">
  <div class="col-md-2">
    <label>Department</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.Department}}" title="{{queryDetail.Department}}" name="queryDetail.Department"
      type="text" class="form-control" disabled />
  </div>
  <div class="col-md-3 col-md-push-1">
    <label>Sub Department</label>
  </div>
  <div class="col-md-3">
    <input nz-input value="{{queryDetail.SubDepartment}}" title="{{queryDetail.SubDepartment}}"
      name="queryDetail.SubDepartment" type="text" class="form-control" disabled />
  </div>
</div>
<div *ngIf="!currentUser.Is_Partner">
  <div class="row form-group">
    <div class="col-md-2">
      <label>CC Sub Departments</label>
    </div>
    <div class="col-md-6" *ngIf="CCSubDepartmentsMaster.length > 0">      
      <nz-select id="ccSubDepartment" [(ngModel)]="selectedCCSubDepts" nzMode="multiple"
                        nzPlaceHolder="Select CC Sub Departments" 
                        style="width: 100%;" nzDisabled>
                        <nz-option *ngFor="let item of CCSubDepartmentsMaster" [nzLabel]="item.item_text"
                            [nzValue]="item.item_id"></nz-option>
                    </nz-select>
      <!-- <ng-multiselect-dropdown disabled [(ngModel)]="selectedCCSubDepts" [ngModelOptions]="{standalone: true}"
          [settings]="dropdownSettings">
        </ng-multiselect-dropdown> -->
    </div>
  </div>
</div>
<div class="row form-group">
  <div class="col-md-2">
    <label>CC</label>
  </div>
  <div class="col-md-6" *ngIf="partnerUserMaster.length > 0">
    <!-- <ng-multiselect-dropdown disabled [(ngModel)]="selectedCCUsers" [ngModelOptions]="{standalone: true}"
        [settings]="dropdownSettings">
      </ng-multiselect-dropdown> -->
    <nz-select nzMode="multiple" nzPlaceHolder="No CC Users" [(ngModel)]="selectedCCUsers" disabled
      style="width: 100%;">
      <nz-option *ngFor="let user of partnerUserMaster" [nzValue]="user.item_id" [nzLabel]="user.item_text"></nz-option>
    </nz-select>
  </div>
</div>
<div class="row form-group">
  <div class="col-md-2 required">
    <label>Partner Comments</label>
  </div>
  <div class="col-md-6">
    <textarea nz-input rows="3" value="{{queryDetail.Partner_Comment}}" name="Partner_Comment" type="text" disabled
      class="form-control"></textarea>
  </div>
  <div class="col-md-3">
    <button (click)="viewAttachments(true)" nz-button nzType="primary" [nzSize]="'small'">
      View Attachments
    </button>
    <div>
      <label> Attachment count - {{partnerUploadedAttachmtCnt}}</label>
    </div>
  </div>
</div>
<div *ngIf="!currentUser.Is_Partner">
  <div class="row form-group">
    <div class="col-md-2">
      <label>Company Restricted</label>
    </div>
    <div class="col-md-6">
      <input type="checkbox" name="Company_Restricted" class="chckbx-Confidential"
        [checked]="queryDetail.Company_Restricted" onclick="return false;" />
    </div>
  </div>
  <div class="row form-group">
    <div class="col-md-2 required">
      <label>Query Category</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryDetail.Category}}" title="{{queryDetail.Category}}" name="queryDetail.Category"
        type="text" class="form-control" disabled />
    </div>

      <div class="col-md-3 col-md-push-1 required" *ngIf="(queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code =='2')">
        <label>Query Sub Category</label>
      </div>
      <div class="col-md-3" *ngIf="(queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code =='2')">
        <input nz-input value="{{queryDetail.SubCategory}}" title="{{queryDetail.SubCategory}}"
          name="queryDetail.SubCategory" type="text" class="form-control" disabled />
      </div>

  </div>
  <div class="row form-group" *ngIf="(queryDetail.Clarification_Cat_Code == '1' || queryDetail.Clarification_Cat_Code == '2'
        && queryDetail.Clarification_SubCat_Code !='' && !isCategoryCommentVisible)">
    <div class="col-md-2">
      <label>Letter Reference Number</label>
    </div>
    <div class="col-md-3">
      <input nz-input value="{{queryDetail.LetterReference_Number}}" name="queryDetail.LetterReference_Number"
        type="text" class="form-control" disabled />
    </div>

      <div class="col-md-3 col-md-push-1" *ngIf="isContractNumberVisible">
        <label>Contract Number</label>
      </div>
      <div class="col-md-3" *ngIf="isContractNumberVisible">
        <input nz-input value="{{queryDetail.Contract_Number}}" name="queryDetail.Contract_Number" type="text"
          class="form-control" disabled />
      </div>
  
    
      <div class="col-md-3 col-md-push-1" *ngIf="isAFEVisible">
        <label>AFE Number</label>
      </div>
      <div class="col-md-3" *ngIf="isAFEVisible">
        <input nz-input value="{{queryDetail.AFE_Number}}" name="queryDetail.AFE_Number" type="text"
          class="form-control" disabled />
      </div>

      <div class="col-md-3 col-md-push-1" *ngIf="isWOVisible">
        <label>Work Order Number</label>
      </div>
      <div class="col-md-3" *ngIf="isWOVisible">
        <input nz-input value="{{queryDetail.Work_Order_Number}}" name="queryDetail.Work_Order_Number" type="text"
          class="form-control" disabled />
      </div>

  </div>
  <div
    *ngIf="(queryDetail.Clarification_Cat_Code != '' && queryDetail.Clarification_Cat_Code != '1' && queryDetail.Clarification_Cat_Code != '2') || (isCategoryCommentVisible)">
    <div class="row form-group">
      <div class="col-md-2 required">
        <label>Category Comments</label>
      </div>
      <div class="col-md-6">
        <textarea nz-input rows="3" value="{{queryDetail.Category_Comments}}" name="CategoryComment" type="text"
          class="form-control" disabled></textarea>
      </div>
    </div>
  </div>
</div>
<div *ngIf="currentUser.Is_Partner">  
  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Query Resolution Details</span>
  </div>
  <br />

  <div class="row form-group">
    <div class="col-md-2">
      <label>Resolution Comments</label>
    </div>
    <div class="col-md-6">
      <textarea nz-input rows="3" value="{{queryDetail.Resolution_Comment}}" name="Resolution_Comment" type="text"
        disabled class="form-control"></textarea>
    </div>
    <div class="col-md-3">
      <button nz-button nzType="primary" [nzSize]="'small'" (click)="viewAttachments(false)">
        View Attachments
      </button>
      <div>
        <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!currentUser.Is_Partner && (queryDetail.QueryDetailStatus != 1 && queryDetail.QueryDetailStatus != 7)">
  <div class="form-row bg-dark-blue text-white">
    <span class="span-header">Query Resolution Details</span>
  </div>
  <br />
  
  <br>
  <div class="row form-group" *ngIf="queryDetail.ConsolidatedComment.length > 0">
    <div class="col-md-2">
      <label>Consolidated Comments</label>
    </div>
    <div class="col-md-6">
      <div>
        <p id="consolidatedComment" class="consolidate-comments" readonly="readonly" style="font-size: 80%;"
          [innerHTML]="queryDetail.ConsolidatedCommentInString" disabled></p>
      </div>
      <div>
        <a (click)="viewComments()" style="cursor: pointer; text-decoration: underline;">View Comments</a>
      </div>
    </div>
    <div class="col-md-3">
      <button (click)="viewAttachments(false)" nz-button nzType="primary" [nzSize]="'small'">View Attachments</button>
      <div>
        <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
      </div>
    </div>
  </div>
  <div class="row form-group">

    <div class="col-md-2" *ngIf="queryDetail.QueryDetailStatus == 6">
      <label>Resolution Comments</label>
    </div>
    <div class="col-md-6" *ngIf="queryDetail.QueryDetailStatus == 6">
      <textarea nz-input rows="3" value="{{queryDetail.Resolution_Comment}}" name="Resolution_Comment" type="text" disabled
        class="form-control"></textarea>
    </div>


    <div class="col-md-2" *ngIf="queryDetail.QueryDetailStatus == 8 || queryDetail.QueryDetailStatus == 9">
      <label>Delete Comment</label>
    </div>
    <div class="col-md-6" *ngIf="queryDetail.QueryDetailStatus == 8 || queryDetail.QueryDetailStatus == 9">
      <textarea rows="3" value="{{queryDetail.Delete_Comment}}" name="DeleteComment" type="text" disabled
        class="form-control"></textarea>
    </div>

    <div class="col-md-3" *ngIf="queryDetail.ConsolidatedComment.length == 0">
      <button (click)="viewAttachments(false)" nz-button nzType="primary" [nzSize]="'small'">View Attachments</button>
      <div>
        <label> Attachment count - {{internalUserUploadedAttachmtCnt}}</label>
      </div>
    </div>
  </div>
</div>
</div>